<template>
	<img :src="logo" alt="" />
</template>
<script>
export default {
	data() {
		return {
			logo: require("@/assets/images/logo/logo-serviroute.png"),
		};
	},
};
</script>
